/**
 * Fulfillment Endpoints
 * FULFILLMENT ADMIN: Order fulfillment management APIs
 */
export const FULFILLMENT_ENDPOINTS = {
  orderListing: 'fulfillment-panel/orders',
  vendorsList: 'fulfillment-panel/vendors',
  vendorBalance: 'fulfillment-panel/vendor-balance',
  approveReject: 'redemption/approve-rejectby-bcp',
  rejectedReasons: 'redemption/rejection-reason',
  egvSummary: 'redemption/egv-summary',
  offerCodeUpload: 'redemption/order-offer-code-upload',
  readOrderStatus: 'redemption/readorderstatus',
  setOrderStatus: 'redemption/setorderstatus',
  deliveryPartner: 'redemption/delivery-partner',
};
